import React from 'react'
import classNames from 'classnames'
import { CaptionMD, CaptionXS } from '@/atoms/Text'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

export type Tab = 'basic' | 'monthly-premium' | 'yearly-premium'
interface FrequencySelectorProps {
  onClick: (tab: Tab) => void
  tabPosition: Tab
}
export const FrequencySelector: React.FC<FrequencySelectorProps> = ({ onClick, tabPosition }) => {
  const { t } = useTranslate('livestream')
  return (
    <div
      className={classNames(
        'relative mx-auto my-6 block h-[50px] w-full max-w-[276px] cursor-pointer rounded-full border-2 border-core-gray-200 bg-core-gray-200 px-[2px] py-1 max-w-[350px]',
      )}
      style={{ WebkitTapHighlightColor: 'transparent' }}
    >
      <div
        className={classNames(
          'w-1/3 absolute h-[42px] top-1/2 -translate-y-1/2 bg-white rounded-full shadow-md transform cursor-pointer transition-all duration-400 transition-timing-function-.22,.68,0,1.71 mx-0.5',
          {
            'translate-x-[0%]': tabPosition == 'basic',
            'translate-x-[97%]': tabPosition == 'monthly-premium',
            'translate-x-[193%]': tabPosition == 'yearly-premium',
          },
        )}
      />
      <div className="absolute top-0 flex h-full w-full items-center justify-center px-2">
        <div className="flex h-full w-1/3 flex-col items-center justify-center" onClick={() => onClick('basic')}>
          <CaptionMD
            weight="bold"
            className="duration-400 transition-all ease-in-out"
            color={tabPosition === 'basic' ? 'core-gray-950' : 'gray-700'}
          >
            <Translate t={t} i18nKey="basic">
              Basic
            </Translate>
          </CaptionMD>
          <CaptionXS className="-mt-1" weight="semibold" color="core-gray-700">
            <Translate i18nKey="monthly" t={t}>
              Monthly
            </Translate>
          </CaptionXS>
        </div>
        <div
          className="flex h-full w-1/3 flex-col items-center justify-center pl-0 pr-2"
          onClick={() => onClick('monthly-premium')}
        >
          <CaptionMD
            weight="bold"
            className="duration-400 transition-all ease-in-out"
            color={tabPosition === 'monthly-premium' ? 'core-gray-950' : 'gray-700'}
          >
            <Translate i18nKey="premium" t={t}>
              Premium
            </Translate>
          </CaptionMD>
          <CaptionXS className="-mt-1" weight="semibold" color="core-gray-700">
            <Translate i18nKey="monthly" t={t}>
              Monthly
            </Translate>
          </CaptionXS>
        </div>
        <div
          className="flex h-full w-1/3 flex-col items-center justify-center pl-2"
          onClick={() => onClick('yearly-premium')}
        >
          <CaptionMD
            weight="bold"
            className="duration-400 transition-all ease-in-out"
            color={tabPosition === 'yearly-premium' ? 'core-gray-950' : 'gray-700'}
          >
            Premium
          </CaptionMD>
          <CaptionXS className="-mt-1" weight="semibold" color="core-gray-700">
            <Translate i18nKey="yearly" t={t}>
              Yearly
            </Translate>
          </CaptionXS>
        </div>
      </div>
    </div>
  )
}
